<template>
  <dx-popup
    :visible="showMe"
    :showTitle="false"
    :drag-enabled="false"
    :width="500"
    :height="300"
  >
    <b-form
      class="mt-4"
      @submit.stop.prevent="onSubmit"
      :class="{ 'needs-validation': !submitted, 'was-validated': submitted }"
      novalidate
      ref="f"
    >
      <b-container fluid>
        <h4 class="text-center mb-5" v-if="site">
          New Equipment for {{ site.name }}
        </h4>
        <b-row>
          <b-col>
            <b-form-group label="Model" :label-cols="2" label-align="right">
              <b-select
                :options="options"
                v-model="dev.device_model_id"
                @change="onSelection"
                required
              >
                <template #first>
                  <b-select-option :value="null" disabled
                    >--Please select a model--</b-select-option
                  >
                </template>
              </b-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group
              label="Asset Tag:"
              :label-cols="2"
              label-align="right"
              :invalid-feedback="validationStat.tag.msg"
            >
              <b-input
                type="text"
                v-model="dev.asset_tag"
                @blur="onBlur"
                :state="validationStat.tag.state"
                :maxlength="255"
                id="tag"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-start">
            <b-button variant="blue" type="submit">Save</b-button>
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button variant="orange" @click="onClose">Cancel</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </dx-popup>
</template>

<script>
import notify from "devextreme/ui/notify";

export default {
  props: ["display"],
  data() {
    return {
      dev: {},
      validationStat: {
        tag: {
          msg: "",
          state: null
        }
      },
      submitted: false
    };
  },
  computed: {
    showMe: {
      get() {
        return this.display;
      }
    },
    site() {
      return this.$store.getters["accounts/currentSite"];
    },
    options() {
      var models = this.$store.getters["sysEquipment/models"];
      var optFormat = mods => {
        var labels = [];
        var resp = [];
        if (!mods) {
          return [];
        }

        debugger;

        //Create labels:
        mods.forEach(o => {
          var l = labels.find(lb => lb === o.manufacturer);
          if (!l) {
            labels.push(o.manufacturer);
          }
        });

        //Build Options:
        labels.forEach(l => {
          var opt = {
            label: l,
            options: []
          };
          var raw = mods.filter(o => o.manufacturer === l);

          raw.forEach(r => {
            opt.options.push({
              value: r.id,
              text: r.model
            });
          });
          resp.push(opt);
        });

        return resp;
      };

      if (models.length == 0) {
        this.$store.dispatch("sysEquipment/getModels").then(rsp => {
          if (rsp) {
            return optFormat(this.$store.getters["sysEquipment/models"]);
          } else {
            return [];
          }
        });
      } else {
        return optFormat(models);
      }
    },
    models() {
      if (!this.$store) {
        return [];
      }
      return this.$store.getters["sysEquipment/models"];
    }
  },
  created() {
    this.reset();
  },
  methods: {
    onClose(e) {
      debugger;
      this.$emit("onStatChange", false);
    },
    onSubmit(e) {
      e.preventDefault();
      this.submitted = true;

      if (!e.target.checkValidity()) {
        for (var el in e.target.elements) {
          var stat = validationStat[el];

          if (stat) {
            stat.msg = e.target.elements[el].validationMessage;
            stat.state = e.target.elements[el].checkValidity();
          }
        }

        return;
      }

      //check if it exists:
      var d = this.site.devices.find(dx => {
        if (dx.asset_tag.length > 0) {
          if (dx.asset_tag === this.dev.asset_tag) {
            return dx;
          }
        }
      });

      if (!d) {
        this.site.devices.push(this.dev);

        this.reset();
        this.$emit("onStatChange", false);
        return;
      } else {
        notify(
          "A device with the same Asset tag already exists!",
          "error",
          4000
        );
        return;
      }
    },
    onBlur(e) {
      debugger;
      var str = typeof e.target.value === "string";
      if (str) {
        e.target.value = e.target.value.trim();
      }

      this.validationStat[e.target.id].msg = e.target.validationMessage;
      this.validationStat[e.target.id].state = e.target.checkValidity();
    },
    onSelection(e) {
      debugger;
      var device = this.models.find(d => d.id === e);

      if (!device) {
        return;
      }

      this.dev.name = device.model;
    },
    reset() {
      this.dev = {
        site_id: this.site.id,
        device_model_id: null,
        name: "",
        asset_tag: "",
        is_active: 1
      };

      this.submitted = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/EquipmentEdit.vue